import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

type CloneProductOptions = {
    productId: number;
    ownedById: number;
    suffix?: string;
};
export const useCloneProduct = () => {
    const query = useMutation({
        mutationFn: async (options: CloneProductOptions) => {
            const { productId, ownedById, suffix = "copy" } = options;

            const response = await loggedInApiCall.post(`/api/products/${productId}/clone`, { ownedById, suffix });
            return response;
        },
    });

    return query;
};
